import React from "react";

import { DropdownMenuItem } from "src/app/components/Dropdown/Dropdown";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ReactComponent as ShowcaseIcon } from "src/images/showcase.svg";

export default function GenerateShowcaseMenuItem({
  handleClick,
}: {
  handleClick: () => void;
}) {
  return (
    <DropdownMenuItem onClick={handleClick}>
      <ShowcaseIcon />
      <IDHFormattedMessage
        id="ws_generate_showcase"
        defaultMessage="Generate showcase"
      />
    </DropdownMenuItem>
  );
}
